<template>
  <div class="phrase-overlay" :style="export_dialog ? 'z-index:300010' : 'z-index:-30000; opacity:0'">
    <transition name="fade">
      <div class="export-dialog" v-if="export_dialog">
        <div class="newmessage-title">
          <span>
            レポートエクスポート
          </span>
          <div class="flex-space"></div>
          <div class="newmessage-button" @click="closeDialog()">
            <font-awesome-icon :icon="['fal', 'times']" />
          </div>
        </div>
        <div class="export-title">
          エクスポートする項目を選択してください
        </div>
        <div class="export-dialog-box">
          <input type="checkbox" class="checkbox-original" v-model="checkList" value="summary" id="summary" />
          <label class="checkbox_inner" for="summary">
            <span style="margin-left:30px; font-weight: 700">サマリーデータ</span>
          </label>
        </div>
        <div class="export-dialog-box">
          <input type="checkbox" class="checkbox-original" v-model="checkList" value="post" id="post" />
          <label class="checkbox_inner" for="post">
            <span style="margin-left:30px; font-weight: 700">投稿データ</span>
          </label>
        </div>
        <div class="export-dialog-box">
          <input type="checkbox" class="checkbox-original" v-model="checkList" value="influencer" id="influencer" />
          <label class="checkbox_inner" for="influencer">
            <span style="margin-left:30px; font-weight: 700">インフルエンサーデータ</span>
          </label>
        </div>
        <div v-show="checkList.includes('post') || checkList.includes('influencer')" style="margin: 20px; font-size:10px" class="flex-row">
          <el-checkbox class="checkbox-show" v-model="extend_item">
            追加項目(インプレッション、リーチなどの任意入力項目)をエクスポート対象に含める
          </el-checkbox>
        </div>

        <div class="list-create-footer">
          <transition name="fade">
            <div style="font-size:11px" v-if="wait_message">
              <font-awesome-icon :icon="['fal', 'exclamation-circle']" style="margin-right: 3px;" />
              データ量が多い場合、エクスポートには数十秒〜数分程度時間がかかる場合があります
            </div>
          </transition>
          <div class="flex-space"></div>
          <el-button @click="closeDialog()">閉じる</el-button>
          <el-button type="primary" @click="exportReport()" :disabled="export_loading">
            <div class="flex-row">
              <font-awesome-icon :icon="['fas', 'cloud-download']" style="margin-right:5px" />
              エクスポート
              <div class="loader--mini" v-show="export_loading"></div>
            </div>
          </el-button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const exportReportAPI = root + "/api/report/export_report";
import FileSaver from "file-saver";

export default {
  name: "reportExportDialog",
  props: ["export_dialog", "report_id"],
  components: {},
  data() {
    return {
      checkList: ["summary", "post", "influencer"],
      extend_item: false,
      export_loading: false,
      wait_message: false,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    permission() {
      return this.$store.state.permission;
    },
    activate() {
      return this.$store.state.activate;
    },
  },
  mounted() {},
  methods: {
    resetItems() {
      this.checkList = ["summary", "post", "influencer"];
      this.extend_item = false;
    },
    closeDialog() {
      this.$emit("update:export_dialog", false);
    },
    exportReport() {
      this.export_loading = true;
      setTimeout(() => {
        if (this.export_loading) this.wait_message = true;
      }, 3000);
      this.axios
        .get(exportReportAPI, {
          params: {
            report_id: this.report_id,
            variables: JSON.stringify(this.checkList),
            variables_extend: JSON.stringify(this.extend_item),
            token: this.token,
            user_token: this.user_token,
          },
        })
        .then((response) => {
          this.export_loading = false;
          this.wait_message = false;
          if (response.data.status == "OK") {
            FileSaver.saveAs(response.data.file, response.data.fileName);
            this.$message({
              message: "「" + response.data.report_name + "」のダウンロードが開始されました",
              type: "success",
              offset: 7,
              showClose: true,
            });
            this.closeDialog();
          } else {
            if (response.data.reason == "trial") {
              this.closeDialog();
              this.$message({
                message: "トライアルでのエクスポート上限回数(5回)に達したため、エクスポートできません",
                type: "error",
                offset: 7,
                showClose: true,
              });
            }
          }
        })
        .catch(() => {
          this.export_loading = false;
          this.wait_message = false;
        });
    },
  },
  watch: {
    export_dialog() {
      if (this.export_dialog == true) this.resetItems();
    },
  },
};
</script>

<style>
.el-checkbox__label {
  display: none;
}
</style>
